// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  eventId: __t.string().primaryKey(),
  lobbyId: __t.string(),
  eventType: __t.string(),
  sourceId: __t.string(),
  targetId: __t.string(),
  damage: __t.f32(),
  posX: __t.i32(),
  posY: __t.i32(),
  sequence: __t.u32(),
  metadata: __t.string(),
});
